module.exports = __webpack_public_path__ + "img/image-detail-error.bc516728.png";